// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const ListRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;
